import { styled } from '@mui/material/styles';
import { useFlags } from 'launchdarkly-react-client-sdk';
import { verifyAuthPermission } from '../../auth/VerifyAuthPermission';
import { AuthPermissions } from '../../auth/AuthPermissions';
import { LaunchDarklyFlags } from '../../launch-darkly';
import { useLocalStorage } from '../../utils/useLocalStorage';
import { useOrganization } from '../../utils/useOrganization';
import { CustomSupportEmailCard } from './OrganizationSettings/CustomSupportEmailCard';
import { HomeCountryConfigurationCard } from './OrganizationSettings/HomeCountryConfigurationCard';
import { RiskyNationsCard } from './OrganizationSettings/RiskyNationsCard';
import { orgHasLicense } from '../Organization/org-utils';

export function OrganizationSettings() {
  const [accessToken = ''] = useLocalStorage('accessToken', '');
  const flags: LaunchDarklyFlags['flags'] = useFlags();

  const canUpdateOrg = verifyAuthPermission(AuthPermissions.UPDATE_ORG);

  const { orgData, organizationError, isLoading, mutate } = useOrganization(accessToken);
  if (organizationError) return <div>failed to load</div>;
  if (isLoading || !orgData) return <div>loading...</div>;
  const isPdmLicense = orgHasLicense(orgData, 'pdm-integration');

  return (
    <StyledCardContainer>
      {isPdmLicense && (
        <CustomSupportEmailCard
          isAdmin={canUpdateOrg}
          currentSupportEmail={orgData.supportEmail}
          lastUpdated={orgData.supportEmailLastUpdated}
          mutate={mutate}
        />
      )}
      <HomeCountryConfigurationCard
        isAdmin={canUpdateOrg}
        currentHomeCountry={orgData.homeCountryCode}
        lastUpdated={orgData.homeCountryCodeLastUpdated}
        mutate={mutate}
      />
      {flags?.geographicRiskSettings && <RiskyNationsCard isAdmin={canUpdateOrg} homeCountryCode={orgData.homeCountryCode} />}
    </StyledCardContainer>
  );
}

const StyledCardContainer = styled('div')`
  display: flex;
  flex-direction: column;
  gap: 24px;
  width: 100%;
  max-width: 1000px;
`;
